import React from "react";
import SplitFundtoTenant from "./splitFundtoTenant";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import { parseLocaleNumber } from "../../../heplers/localeFormat";

function FundtoCategorymapper({
  transactionAmount,
  array,
  setArray,
  handleOnAdd,
  remainingItems,
  handleOnChange,
  enableAmountError,
  disableAmountError
}) {

  return (
    <div>
      {array.map((item, index) => {
        return (
          <Grid item xs={12} sm={12} md={12} lg={12} key={index}>
            <SplitFundtoTenant
            enableAmountError={enableAmountError}
            disableAmountError={disableAmountError}
              showButton={array.length - 1 == index}
              item={item}
              index={index}
              remainingItems={remainingItems}
              onSubmit={handleOnAdd}
              onChanged={handleOnChange}
              balance={
                transactionAmount -
                _.sumBy(array.slice(0, -1), (x) => parseLocaleNumber(x.amount) || 0)
              }
              deleteItem={() => {}}
            />
          </Grid>
        );
      })}
    </div>
  );
}

export default FundtoCategorymapper;
